<template>
    <div class="fSize">
        <!--<p>体检用户管理</p>-->
        <!--<van-notice-bar left-icon="info-o">用户管理目前限制维护1人，可左滑删除</van-notice-bar>-->
        <!-- 联系人卡片 -->
        <van-contact-card v-show="!isUserBind" type="add" @click="goUserAdd" add-text="新建体检用户"/>
        <div style="padding:0 0.24rem 0.24rem;background:#fff" v-show="isUserBind">
            <van-field :border="false" left-icon="user-o" label="预约用户" v-model="userInfo.name"
                       input-align="right" :disabled="!isEdit" :class="isEdit?'edit-cell':''"/>
            <van-field :border="false" left-icon="idcard" label="证件号码"
                       v-model="userInfo.cardNumber" input-align="right" style=" border-top: 1px solid #f0f0f0;"
                       :disabled="!isEdit" :class="isEdit?'edit-cell':''"/>
            <van-field :border="false" left-icon="phone-o" label="手机号码"
                       v-model="userInfo.phoneNumber" input-align="right"
                       style=" border-top: 1px solid #f0f0f0; border-bottom: 1px solid #f0f0f0;"
                       :disabled="!isEdit" :class="isEdit?'edit-cell':''"/>
        </div>
        <van-cell class="buttonFixed" safe-area-inset-bottom v-show="isUserBind">
            <van-button :text="isEdit?'保 存':'编 辑'" round type="info" @click="editUser(userInfo.id)" style="width:50%"/>
            <van-button text="删 除" type="danger" round @click="deleteUser(userInfo.id)" style="width:50%"/>
        </van-cell>
        <!--去用户绑定页面-->
        <van-action-sheet safe-area-inset-bottom :round="false" v-model="show" title="体检用户绑定"
                          :close-on-click-overlay="false" @click-overlay="tipsFun">
            <UserAdd @fatherMethod="closeFun"></UserAdd>
        </van-action-sheet>
    </div>
</template>
<script>
    import {
        ContactCard, Button, Toast, NoticeBar, Dialog, SwipeCell, Cell, Row, Col, ActionSheet, Icon, Field, CellGroup,
        Divider
    } from "vant";
    import {getUser, updateUser, delUser} from "@/api/user";
    import UserAdd from "@/components/UserAdd";

    export default {
        components: {
            [ContactCard.name]: ContactCard, [Button.name]: Button, [Toast.name]: Toast, [NoticeBar.name]: NoticeBar,
            [Dialog.name]: Dialog, [SwipeCell.name]: SwipeCell, [Cell.name]: Cell, [Row.name]: Row, [Col.name]: Col,
            [ActionSheet.name]: ActionSheet, UserAdd, [Icon.name]: Icon, [Field.name]: Field,
            [CellGroup.name]: CellGroup, [Divider.name]: Divider
        },
        data() {
            return {
                limit: 1, //用户限制维护个数
                list: [], //用户列表
                // 用户信息，取用户列表中的第1个
                userInfo: {},
                show: false,
                // 是否编辑用户信息
                isEdit: false,
                // 是否绑定了用户信息，true-绑定了，false-没绑定
                isUserBind: false
            };
        },
        created() {
            const that = this;
            //获取当前维护的账户
            that.gainUser();
        },
        mounted() {
            window.history.pushState(null, null, "#");
            window.addEventListener(
                "popstate",
                function (e) {
                    WeixinJSBridge.call("closeWindow");
                },
                false
            );
        },
        methods: {
            //获取维护的用户
            gainUser() {
                const that = this;
                that.isUserBind = sessionStorage.getItem("userIsBang") === "yes";
                if (!that.isUserBind) {
                    //如果用户信息为空则去设置用户
                    that.show = true;
                    return false;
                }
                that.list = [];
                getUser({openId: sessionStorage.getItem("openid")}).then(resp => {
                    if (resp.code === 200) {
                        that.list = resp.data ? resp.data : [];
                        if (that.list && that.list.length > 0) {
                            that.userInfo = that.list[0];
                        }
                        sessionStorage.setItem("userIsBang", that.list.length > 0 ? "yes" : "no");
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 编辑用户信息
            async editUser(id) {
                const that = this;
                if (!that.isEdit) {
                    that.isEdit = true;
                } else {
                    Dialog.confirm({
                        message: "确认保存用户信息吗？"
                    }).then(async () => {
                        let res = await updateUser(that.userInfo);
                        Toast({
                            type: "success",
                            message: res.msg,
                            duration: 2000
                        });
                        that.isEdit = false;
                        // 刷新信息
                        setTimeout(() => {
                            that.gainUser();
                        }, 3000);
                    }).catch(() => {
                        console.log("取消保存");
                    });
                }
            },
            //删除用户
            deleteUser(e) {
                const that = this;
                that.isEdit = false;
                Dialog.confirm({
                    message: "确认解绑用户信息吗？"
                }).then(() => {
                    delUser({id: e}).then(resp => {
                        if (resp.code === 200) {
                            Toast({
                                type: "success",
                                message: "删除成功",
                                duration: 2000,
                                onOpened: function () {
                                    that.list = [];
                                    that.isUserBind = false;
                                    sessionStorage.setItem("userIsBang", "no");
                                    setTimeout(() => {
                                        that.gainUser();
                                    }, 3000);
                                }
                            });
                        } else {
                            Toast({
                                type: "fail",
                                message: resp.msg
                            });
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }).catch(() => {
                    console.log("取消了解绑...");
                });
            },
            //去添加页面
            goUserAdd() {
                const that = this;
                that.show = true;
            },
            //关闭添加框组件
            closeFun() {
                const that = this;
                that.show = false;
                that.isUserBind = true;
                //刷新列表数据
                that.gainUser();
            },
            //判断是否绑定
            tipsFun() {
                if (sessionStorage.getItem("userIsBang") !== "yes") {
                    Toast("请先绑定用户信息...");
                }
            }
        }
    };
</script>
<style lang=scss>
    .edit-cell {
        .van-field__label {
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-user-o::before {
            content: "\F0D4";
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-idcard::before {
            content: "\F073";
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-phone-o::before {
            content: "\F09A";
            color: #000;
            font-size: 0.32rem;
        }
    }

    .van-field--disabled .van-field__label {
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-user-o::before {
        content: "\F0D4";
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-idcard::before {
        content: "\F073";
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-phone-o::before {
        content: "\F09A";
        color: grey;
        font-size: 0.32rem;
    }

    .van-field__control:disabled {
        color: grey;
        -webkit-text-fill-color: grey;
    }
</style>
